export const AuthActionTypes = {
  API_RESPONSE_SUCCESS: '@@auth/API_RESPONSE_SUCCESS',
  API_RESPONSE_ERROR: '@@auth/API_RESPONSE_ERROR',

  LOGIN_USER: '@@auth/LOGIN_USER',
  LOGIN_USER_INFOTOOLS: '@@auth/LOGIN_USER_INFOTOOLS',
  LOGOUT_USER: '@@auth/LOGOUT_USER',
  LOGOUT_USER_INFOTOOLS: '@@auth/LOGOUT_USER_INFOTOOLS',
  SIGNUP_USER: '@@auth/SIGNUP_USER',
  FORGOT_PASSWORD: '@@auth/FORGOT_PASSWORD',
  FORGOT_PASSWORD_CHANGE: '@@auth/FORGOT_PASSWORD_CHANGE',

  UPDATE_DESTINATION_IN_TOKEN: '@@auth/UPDATE_DESTINATION_IN_TOKEN',

  UPDATE_AVATAR: '@@auth/UPDATE_AVATAR',

  RESET: '@@auth/RESET',
  RESET_INFOTOOLS: '@@auth/RESET_INFOTOOLS'
}
